import { createStructuredSelector } from 'reselect'

import {
  SECTION_LIST,
  SECTION_LIST_SUCCESS, 
  SECTION_LIST_ERROR,
  SECTION_PAGE_SET,
  SECTION_SEARCH_SET,
  SECTION_SEARCH_CHANGE,
  SECTION_SEARCH_ASSESSMENT_LIST,
  SECTION_SEARCH_ASSESSMENT_LIST_SUCCESS,
  SECTION_SEARCH_ASSESSMENT_LIST_ERROR, 
  SECTION_ADD_SET,
  SECTION_ADD_MODAL_SET,
  SECTION_ADD,
  SECTION_ADD_SUCCESS,
  SECTION_ADD_ERROR,
  SECTION_ADD_CHANGE,
  SECTION_DETAIL,
  SECTION_DETAIL_SUCCESS,
  SECTION_DETAIL_ERROR,
  SECTION_VIEW_MODAL_SET,
  SECTION_EDIT_CHANGE,
  SECTION_EDIT_MODAL_SET,
  SECTION_UPDATE,
  SECTION_UPDATE_SUCCESS,
  SECTION_UPDATE_ERROR,
  SECTION_VIEW_TAB_SET,
  SECTION_UPLOAD_SET,
  SECTION_UPLOAD_SET_SUCCESS,
  SECTION_UPLOAD_SET_ERROR,
  SECTION_UPLOAD_RESET
} from '../../actions';

export const NAME = 'section';

export const SectionList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: SECTION_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const SectionListSuccess = (data) => ({
  type: SECTION_LIST_SUCCESS,
  payload: data
});

export const SectionListError = (error) => ({
  type: SECTION_LIST_ERROR,
  payload: error
});

export const SectionPageSet = (data) => ({
  type: SECTION_PAGE_SET,
  payload: data
});

export const SectionSearchSet = (data) => ({
  type: SECTION_SEARCH_SET,
  payload: data
});

export const SectionSearchChangeSet = (data) => ({
  type: SECTION_SEARCH_CHANGE,
  payload: data
});

export const SectionSearchAssessmentList = (data) => ({
  type: SECTION_SEARCH_ASSESSMENT_LIST,
  payload: data
});

export const SectionSearchAssessmentListSuccess = (message) => ({
  type: SECTION_SEARCH_ASSESSMENT_LIST_SUCCESS,
  payload: message
});

export const SectionSearchAssessmentListError = (error) => ({
  type: SECTION_SEARCH_ASSESSMENT_LIST_ERROR,
  payload: error
}); 

export const SectionAddChangeSet = (data) => ({
  type: SECTION_ADD_CHANGE,
  payload: data
});

export const SectionAddSet = (data) => ({
  type: SECTION_ADD_SET,
  payload: data
});

export const SectionAddModalSet = (data) => ({
  type: SECTION_ADD_MODAL_SET,
  payload: data
});

export const SectionAdd = (data) => ({
  type: SECTION_ADD,
  payload: data
});

export const SectionAddSuccess = (message) => ({
  type: SECTION_ADD_SUCCESS,
  payload: message
});

export const SectionAddError = (error) => ({
  type: SECTION_ADD_ERROR,
  payload: error
});

export const SectionDetail = (data) => ({
  type: SECTION_DETAIL,
  payload: data
});

export const SectionDetailSuccess = (data) => ({
  type: SECTION_DETAIL_SUCCESS,
  payload: data
});

export const SectionDetailError = (error) => ({
  type: SECTION_DETAIL_ERROR,
  payload: error
});

export const SectionViewModalSet = (data) => ({
  type: SECTION_VIEW_MODAL_SET,
  payload: data
});

export const SectionEditModalSet = (data) => ({
  type: SECTION_EDIT_MODAL_SET,
  payload: data
});

export const SectionEditChangeSet = (data) => ({
  type: SECTION_EDIT_CHANGE,
  payload: data
});

export const SectionUpdate = (data) => ({
  type: SECTION_UPDATE,
  payload: data
});

export const SectionUpdateSuccess = (message) => ({
  type: SECTION_UPDATE_SUCCESS,
  payload: message.message
});

export const SectionUpdateError = (error) => ({
  type: SECTION_UPDATE_ERROR,
  payload: error
});

export const SectionViewTabSet = (data) => ({
  type: SECTION_VIEW_TAB_SET,
  payload: data
});

export const SectionUploadSet = (file) => ({
  type: SECTION_UPLOAD_SET,
  payload: { file },
});

export const SectionUploadSetSuccess = (items) => ({
  type: SECTION_UPLOAD_SET_SUCCESS,
  payload: items,
});

export const SectionUploadSetError = (error) => ({
  type: SECTION_UPLOAD_SET_ERROR,
  payload: error,
});

export const SectionUploadReset= () => ({
  type: SECTION_UPLOAD_RESET
});

const section = (state) => state[NAME];

export const SectionSelector = createStructuredSelector({
  section
})
 